import React from "react";
import { RouteComponentProps } from "polyrouter";
import { DeleteModal, useModalDispatch } from "collections/Modal";
import {
  useDeleteTeamsWebhookMutation,
  useGetTeamsHookQuery
} from "generated/graphql";
import { DISMISS, useNotification } from "collections";
import { useTranslation } from "utilities/i18n";

export const DeleteTenantWebhook: React.FC<RouteComponentProps<{
  webHooksId: string;
  id: string;
}>> = ({
  match: {
    params: { webHooksId }
  }
}) => {
  const dispatch = useModalDispatch();
  const [addNotification] = useNotification();
  const { t } = useTranslation();
  const { data } = useGetTeamsHookQuery({
    variables: {
      id: webHooksId
    }
  });
  const [{ fetching }, deleteIt] = useDeleteTeamsWebhookMutation();
  return (
    <DeleteModal
      name="DeleteTeamsWebhook"
      confirmationString={t("CONFIRM_DELETE_WEBHOOK")}
      disabled={fetching}
      entity={data?.ncTeams?.webhook?.name ?? ""}
      onDelete={async () => {
        await deleteIt({
          id: webHooksId
        });
        dispatch();
        addNotification({
          type: "success",
          message: t("NOTIFICATION_WEBHOOK_DELETED", {
            name: data?.ncTeams.webhook?.name
          }),
          dismiss: DISMISS.FAST,
          persistThroughNav: true
        });
      }}
    />
  );
};
